var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/email") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.5454545,5 C19.8973239,5 21,6.04822297 21,7.33333333 L21,16.6666667 C21,17.951777 19.8973239,19 18.5454545,19 L5.45454545,19 C4.10267611,19 3,17.951777 3,16.6666667 L3,7.33333333 C3,6.04822297 4.10267611,5 5.45454545,5 Z M19.363,8.827 L12.4691965,13.4149582 C12.2187818,13.5815921 11.8946933,13.600107 11.6279067,13.4705028 L11.5308035,13.4149582 L4.636,8.827 L4.63636364,16.6666667 C4.63636364,17.0598981 4.9516735,17.3898857 5.35264961,17.4383262 L5.45454545,17.4444444 L18.5454545,17.4444444 C18.9935852,17.4444444 19.3636364,17.0926674 19.3636364,16.6666667 L19.363,8.827 Z M18.5454545,6.55555556 L5.45454545,6.55555556 C5.13732476,6.55555556 4.85922874,6.73182668 4.72382197,6.98591866 L12,11.8281111 L19.276178,6.98591866 C19.1407713,6.73182668 18.8626752,6.55555556 18.5454545,6.55555556 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/email",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/black",
    mask: "url(#mask-2)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.22f5a53ddaa9b303ac06aaf8fd77fca4.svg";
export { ForwardRef as ReactComponent };